import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'HOME', href: '/' },
  { label: 'CEILING FANS', href: '/collection/ceiling-fans' },
  { label: 'LIGHT FANS', href: '/collection/light-fans' },
  { label: 'OVERSIZED FANS', href: '/collection/oversized-fans' },
  { label: 'FANDELIERS', href: '/collection/fandeliers' },
  { label: 'WALL FANS', href: '/collection/wall-fans' },
  { label: 'MULTI PURPOSE FANS', href: '/collection/multi-purpose-fans' },
  { label: 'SHOWROOMS', href: '/display-centres' },
  { label: 'FAQs', href: '/faqs' },
  {
    label: 'DOWNLOAD PRODUCT CATALOGUE',
    href: 'https://customer-assets.emergentagent.com/job_fanco-preview/artifacts/axwo21az_Product%20catalog%202026..pdf',
    external: true,
  },
  {
    label: 'DOWNLOAD PRICE LIST',
    href: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/bb12aabf68f87e43_Bernard%20Fan%20Co.%20Price%20List%201-11-26.pdf',
    external: true,
  },
  { label: 'CONTACT US', href: '/contact-us' },
];

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-stone-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1700px] mx-auto px-4 lg:px-6">
          <div className="flex items-center h-20 gap-3 sm:gap-5">
            <button
              onClick={() => setIsMenuOpen(true)}
              data-testid="open-menu-button"
              aria-label="Open navigation menu"
              className="flex items-center gap-2 text-stone-900 p-2 -ml-2 hover:text-stone-600 transition-colors duration-200"
            >
              <Menu size={26} />
              <span className="hidden sm:inline text-xs font-bold tracking-widest">MENU</span>
            </button>

            <div className="flex-shrink-0">
              <a href="/" className="inline-block" data-testid="header-logo-link">
                <h1
                  className="text-xl sm:text-2xl 2xl:text-3xl font-bold tracking-wider text-stone-900 underline whitespace-nowrap"
                  style={{ fontFamily: 'Arial, sans-serif' }}
                >
                  BERNARD FAN CO.
                </h1>
                <p
                  className="text-xl sm:text-2xl 2xl:text-3xl text-stone-900 font-bold mt-1 whitespace-nowrap"
                  style={{ fontFamily: 'Arial, sans-serif', transform: 'scaleX(0.93)', transformOrigin: 'left center' }}
                >
                  LUXURY DESIGNER FANS
                </p>
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Backdrop */}
      <div
        onClick={() => setIsMenuOpen(false)}
        data-testid="menu-backdrop"
        className={`fixed inset-0 z-[60] bg-stone-900/50 backdrop-blur-sm transition-opacity duration-300 ${
          isMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      />

      {/* Left slide-out drawer */}
      <aside
        data-testid="nav-drawer"
        className={`fixed top-0 left-0 z-[70] h-full w-[320px] max-w-[85vw] bg-stone-50 shadow-2xl transition-transform duration-300 ease-out ${
          isMenuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between px-6 h-20 border-b border-stone-200">
          <span
            className="text-lg font-bold tracking-wider text-stone-900"
            style={{ fontFamily: 'Arial, sans-serif' }}
          >
            MENU
          </span>
          <button
            onClick={() => setIsMenuOpen(false)}
            data-testid="close-menu-button"
            aria-label="Close navigation menu"
            className="text-stone-900 p-2 -mr-2 hover:text-stone-600 transition-colors duration-200"
          >
            <X size={24} />
          </button>
        </div>

        <nav className="flex flex-col px-6 py-4 overflow-y-auto h-[calc(100%-5rem)]">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              onClick={() => setIsMenuOpen(false)}
              data-testid={`drawer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              className="block text-sm tracking-widest text-stone-900 font-bold hover:text-stone-500 hover:translate-x-1 transition-all duration-200 py-3.5 border-b border-stone-200/70"
            >
              {link.label}
            </a>
          ))}
        </nav>
      </aside>
    </>
  );
};
